(function () {
  try {
    var KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'];
    var MAX_AGE = 60 * 60 * 24 * 90; // 90 days
    var params = new URLSearchParams(window.location.search);

    function setC(k, v) {
      document.cookie = 'pa_' + k + '=' + encodeURIComponent(v) + ';path=/;max-age=' + MAX_AGE + ';SameSite=Lax';
    }
    function getC(k) {
      var m = document.cookie.match(new RegExp('(?:^|; )pa_' + k + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }

    // Save UTM parameters to cookies if present in URL
    if (KEYS.some(function (k) { return params.get(k); })) {
      KEYS.forEach(function (k) { setC(k, (params.get(k) || '').slice(0, 500)); });
    }

    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;

    function fillFields() {
      // 1. Direct name attribute match (e.g. name="utm_source" or name="contact[utm_source]")
      KEYS.forEach(function (k) {
        var v = getC(k);
        if (!v) return;

        var directInputs = document.querySelectorAll('form input[name="' + k + '"], form input[name$="[' + k + ']"]');
        directInputs.forEach(function (el) {
          if (el.value === v) return;
          setter.call(el, v);
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // 2. Powerful Forms _keyLabel match (e.g. name="hidden-1" where label is "utm_source")
      var keyLabelInput = document.querySelector('input[name="_keyLabel"]');
      if (keyLabelInput && keyLabelInput.value) {
        try {
          var labelMap = JSON.parse(keyLabelInput.value);
          var form = keyLabelInput.closest('form');
          if (form) {
            Object.keys(labelMap).forEach(function (inputName) {
              var label = (labelMap[inputName] || '').trim();
              if (KEYS.indexOf(label) !== -1) {
                var v = getC(label);
                if (!v) return;
                var targetInput = form.querySelector('input[name="' + inputName + '"]');
                if (targetInput && targetInput.value !== v) {
                  setter.call(targetInput, v);
                  targetInput.dispatchEvent(new Event('input', { bubbles: true }));
                  targetInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            });
          }
        } catch (err) {}
      }
    }

    fillFields();
    document.addEventListener('DOMContentLoaded', fillFields);
    document.addEventListener('submit', fillFields, true);
    var obs = new MutationObserver(fillFields);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  } catch (e) {}
})();